<div class="alignment_contnet">
    <div class="container col-10">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 p-0 card-right">
                <div class="card">
                    <div class="card-body">
                        <div class="container-fluid">
                            <div class="col-12 mt-5 d-flex justify-content-around">
                                <div class="card col-12 p-4">
                                    <label>Enter the class code</label>
                                    <input class="form-control" [(ngModel)]="classCode" placeholder="Enter the class code">
                                </div>
                            </div>
                            <div class="col-12 text-right">
                                <button type="button" class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}" (click)="enrollClass()">Join Class
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
